import { httpClient } from '@/api/http-client'
import { Dependent } from '@/types'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type Params = {
  companyKey: string
  partnerKey: string
}

export const listDependents = async ({ companyKey, partnerKey }: Params) => {
  const response = await httpClient('accounting-dealer').get<Dependent[]>(
    `/v3/company/${companyKey}/partner/${partnerKey}/dependents`,
  )
  return response.data
}

export const useListDependents = (
  params: Params,
  options?: Partial<UseQueryOptions<Dependent[]>>,
) => {
  return useQuery({
    queryKey: ['dependents', params],
    queryFn: () => listDependents(params),
    enabled: Boolean(params.companyKey && params.partnerKey),
    ...options,
  })
}
